export default "__VITE_ASSET__Bd34Slvo__"